import { Listener } from './Listener';
import { detectFormTest } from '../../helpers/detect-form-test';
import { TrackingHandler } from '../TrackingHandler';
export class GtmListener extends Listener {
    formStart(eventId, formName, inputName) {
        const dataLayerMkt = {
            form: {
                name: formName,
                input: inputName,
            },
            page: {
                product: window.page.product,
            },
        };
        this.pushGtmEvent('MKT Form Started', dataLayerMkt);
    }
    formNavigate(eventId, formName, formStep, navigationAction, data) {
        const dataLayerMkt = {
            form: {
                name: formName,
                step: formStep,
                input: navigationAction,
            },
        };
        this.pushGtmEvent('MKT Form Navigated', dataLayerMkt);
    }
    formSubmit(eventId, formName, data) { }
    formSubmitResult(eventId, formName, submitData, statusCode, responseData) {
        if (TrackingHandler.getInstance().isInternalTest) {
            return;
        }
        if (formName.toLowerCase().includes('consent')) {
            return;
        }
        if (detectFormTest(submitData)) {
            return;
        }
        if (statusCode < 200 || statusCode >= 300) {
            return;
        }
        if (!responseData) {
            return;
        }
        if (!responseData.t) {
            return;
        }
        const dataLayerMkt = {
            form: {
                name: formName,
                eventId: 'vfs_' + eventId,
                transactionId: responseData.i || '',
            },
            page: {
                product: window.page.product,
            },
        };
        this.pushGtmEvent('MKT Form Submitted', dataLayerMkt);
    }
    softConversion(eventId, source) {
        const dataLayerMkt = {
            softConversionSource: source,
            visitId: TrackingHandler.getInstance().visitId || '',
            page: {
                product: window.page.product,
            },
        };
        this.pushGtmEvent('MKT Soft Conversion', dataLayerMkt);
    }
    chatStart(eventId) {
    }
    chatEnd(eventId) {
    }
    pushGtmEvent(eventName, dataLayerMkt) {
        if (TrackingHandler.getInstance().isInternalTest) {
            return;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            mkt: dataLayerMkt,
        });
    }
}
